module.exports = new __parcel__URL__("logo.28997902.png").toString();